// 高德地图 JS API 动态加载
// 按需加载（打开位置选择器时才加载），不影响首屏性能
let mapPromise = null;

export function loadAMap() {
	if (window.AMap) return Promise.resolve(window.AMap);
	if (mapPromise) return mapPromise;
	// 安全密钥必须在加载脚本之前设置
	window._AMapSecurityConfig = {
		securityJsCode: process.env.VUE_APP_AMAP_SECURITY_CODE
	};
	mapPromise = new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = `https://webapi.amap.com/maps?v=2.0&key=${process.env.VUE_APP_AMAP_KEY}&plugin=AMap.PlaceSearch,AMap.Geocoder`;
		script.async = true;
		script.onload = () => resolve(window.AMap);
		script.onerror = () => {
			mapPromise = null;
			reject(new Error('高德地图加载失败'));
		};
		document.head.appendChild(script);
	});
	return mapPromise;
}
